import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag-state lg rounded-50 flex align-items-center gap-4 px-4 py-4 mb-6" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = { class: "my-1" }
const _hoisted_5 = { class: "form" }

import { reactive, ref } from 'vue';
    import OnboardingPayslipUploadInput from './components/OnboardingPayslipUploadInput.vue';
    
    interface FormParams {
        user: any;
        photo: any;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPayslipDocumentsForm',
  props: {
        formParams: { type: Object as () => FormParams, required: true },
        loading: { type: Boolean, default: false }
    },
  emits: ['saved', 'previous'],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emit = __emit;
    
    const isFormValid = ref(false);
    const formData = reactive({
        bulletin1: null as any,
        bulletin2: null as any,
        bulletin3: null as any,
    });
    const errors = reactive({
        bulletin1: '',
        bulletin2: '',
        bulletin3: '',
    });

    function validate() {
        let isValid = true;

        errors.bulletin1 = '';
        if (!formData.bulletin1) {
            errors.bulletin1 ="Le bulletin 1 est requis";
            isValid = false;
        }

        errors.bulletin2 = '';
        if (!formData.bulletin2) {
            errors.bulletin2 ="Le bulletin 2 est requis";
            isValid = false;
        }

        errors.bulletin3 = '';
        if (!formData.bulletin3) {
            errors.bulletin3 ="Le bulletin 3 est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFileUploaded(field: 'bulletin1' | 'bulletin2' | 'bulletin3', uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData[field] = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    function goToPreviousStep() {
        emit('previous');
    }

    async function onSubmit() {
        if (!validate()) { return; }
        emit('saved', formData);
    }


return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.formParams.photo?.preview ? __props.formParams.photo.preview : '/assets/users/300w/user2.jpg',
        class: "rounded-100 overflow-hidden size-2xl"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.formParams.user.nom + ' ' + __props.formParams.user.prenom), 1),
        _createTextVNode(" " + _toDisplayString(__props.formParams.user.email + ' | ' + __props.formParams.user.telephone), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "rounded-100 overflow-hidden size-2xl ml-auto" }, [
        _createElementVNode("img", {
          src: "/icons/icon-coop-finance.svg",
          width: "100%"
        })
      ], -1))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Charger vos 3 derniers bulletins de salaire", -1)),
    _createElementVNode("form", _hoisted_5, [
      _createVNode(OnboardingPayslipUploadInput, {
        id: "bulletin1-upload",
        onUploaded: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded('bulletin1', $event))),
        caption: ".1",
        label: "Bulletin de salaire (1)",
        required: ""
      }),
      _createVNode(OnboardingPayslipUploadInput, {
        id: "bulletin2-upload",
        onUploaded: _cache[1] || (_cache[1] = ($event: any) => (onFileUploaded('bulletin2', $event))),
        caption: ".2",
        label: "Bulletin de salaire (2)",
        required: ""
      }),
      _createVNode(OnboardingPayslipUploadInput, {
        id: "bulletin3-upload",
        onUploaded: _cache[2] || (_cache[2] = ($event: any) => (onFileUploaded('bulletin3', $event))),
        caption: ".3",
        label: "Bulletin de salaire (3)",
        required: ""
      }),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, DOC, XLS. Taille max: 5MB. ", -1)),
      _createVNode(_component_custom_button, {
        type: "button",
        id: "btn-save-payslip-documents",
        onClick: onSubmit,
        class: "btn lg w-100 flex-center mt-5 mb-6",
        loading: props.loading
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: "/icons/icon-valider.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Valider", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createElementVNode("a", {
        href: "javascript:;",
        onClick: _withModifiers(goToPreviousStep, ["prevent"])
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("h5", { class: "flex-center gap-4 text-primary-color text-center" }, [
          _createElementVNode("img", {
            src: "/icons/icon-back.svg",
            class: "size-medium",
            alt: ""
          }),
          _createTextVNode(" Etape précedente ")
        ], -1)
      ]))])
    ])
  ]))
}
}

})